import { render, staticRenderFns } from "./ForwardButton.vue?vue&type=template&id=182bd8a6&"
import script from "./ForwardButton.vue?vue&type=script&lang=js&"
export * from "./ForwardButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports